import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { NovoSellRetryModule } from '@/modules/novo-sell-retry';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/novo-sell-retry')({
  component: NovoSellRetryPage,
});

function NovoSellRetryPage() {
  const { canAccessNovoSellRetry } = useAccessControl();

  if (!canAccessNovoSellRetry) {
    return <AccessDenied />;
  }

  return <NovoSellRetryModule />;
}
